import IOption from "../../../shared-ui/common/option";
import { IFilterProps, SelectFilter } from "../../../shared-ui/filters/select-filter";

interface IStoragePoolFilterProps extends IFilterProps<string, string> {
    storagePoolOptions: IOption<string>[];
}

export function ShardClusterFilter(props: IStoragePoolFilterProps) {

    return SelectFilter({
        testId: "shard-cluster-filter",
        label: "Shard Cluster",
        options: () => Promise.resolve(props.storagePoolOptions),
        ...props
    });
}
